export default __webpack_public_path__ + "90abf05.png";